<template>
  <b-row>
    <b-col
      cols="12"
      md="12"
      class="mb-2 mt-2"
    >
      <h4>Tedarikçi Seçimi</h4>
    </b-col>
    <b-col
      cols="12"
      md="12"
      class="mb-2"
    >
      <b-input-group>
        <b-form-input
          v-model="searchText"
          placeholder="Tedarikçi Ara.."
          @keydown.enter="searchData"
        />
        <template #append>
          <b-button
            variant="outline-primary"
            @click="searchData"
          >
            <feather-icon icon="SearchIcon" />
          </b-button>
        </template>
      </b-input-group>
    </b-col>
    <b-col
      cols="12"
      md="12"
    >
      <b-table
        responsive="sm"
        :fields="fields"
        :items="dataList"
        striped
      >
        <template #cell(title)="data">
          <div v-if="data.item.tax_number">
            <small class="text-primary">{{ data.item.tax_number }}</small>
          </div>
          {{ data.item.title }}
        </template>
        <template #cell(control)="data">
          <div class="text-right">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="callBack(data.item,1)"
            >
              Seç
            </b-button>
          </div>
        </template>
      </b-table>
      <b-card-footer>
        <b-pagination
          v-model="currentPage"
          :total-rows="dataCounts"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-card-footer>
    </b-col>
  </b-row>
</template>
<script>
import {
  BTable, BPagination, BButton, BCardFooter, BRow, BCol, BInputGroup, BFormInput,
} from 'bootstrap-vue'

const tableName = 'suppliers'
export default {
  name: 'PurchaseOffersSuppliersListTable',
  components: {
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    BRow,
    BCol,
    BInputGroup,
    BFormInput,
  },
  props: {
    callBack: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      searchText: null,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'title',
          label: 'Tedarikçi',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.company AS title`,
          `${tableName}.tax_number AS tax_number`,
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['suppliers/dataList']
    },
    dataCounts() {
      return this.$store.getters['suppliers/dataCounts']
    },
    saveData() {
      return this.$store.getters['suppliers/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    searchData() {
      if (this.searchText) {
        this.dataQuery.or_like = {
          'suppliers.company': this.searchText,
          'suppliers.phone': this.searchText,
          'suppliers.phone2': this.searchText,
          'suppliers.fax': this.searchText,
          'suppliers.email': this.searchText,
          'suppliers.tax_number': this.searchText,
        }
      } else {
        this.dataQuery.or_like = {}
      }
      this.getDataList()
    },
    getDataList() {
      this.$store.dispatch('suppliers/getDataList', this.dataQuery)
    },
  },
}
</script>
